import { httpClient, httpClient3 } from "./Api";
import { message } from "antd";

const showUrl = false;

const typedResponse = (type, callbackFun, data, url) => {
  if (typeof data === "string") {
    if (callbackFun) callbackFun(data === "No Record Found" ? [] : data);
    return;
  }
  if (
    Array.isArray(data) ||
    (typeof data === "object" &&
      data !== null &&
      !data.hasOwnProperty("IsSuccessfull"))
  ) {
    return callbackFun(data);
  }
  if (callbackFun) {
    if (typeof data.data == "boolean") {
      callbackFun(data.data);
    } else if (data.IsSuccessfull && data.StatusCode === 200) {
      if (type === "data") {
        if (
          !data.dataSet &&
          !data.ResponseArray &&
          data.Data &&
          typeof data.Data === "object" &&
          Object.keys(data.Data).length > 0
        ) {
          return callbackFun(data.Data);
        }
        if (data.dataSet) return callbackFun(data.dataSet);
        callbackFun(data.ResponseArray);
      }
      if (data.Id) {
        const isSavePosResponse = url === "Pharmacy/POS/SavePOS";
        const extra = isSavePosResponse ? { No: data.No } : {};
        return callbackFun({
          id: data.Id,
          message: data.Message || "",
          ...extra,
        });
      } else if (type === "msg") {
        return callbackFun(data.Message);
      }
      if (
        data?.DataSet &&
        typeof data.DataSet === "object" &&
        Object.keys(data.DataSet).length > 0
      ) {
        return callbackFun(data.DataSet);
      } else if (type === "msg") {
        return callbackFun(data.Message);
      }
    } else if (data.StatusCode === 404 && data.Message === "No Data Found") {
      callbackFun([]);
    } else {
      message.error(data.Message);
    }
  }
};

const oldTypedResponse = (type, callbackFun, data) => {
  if (callbackFun) {
    if (Array.isArray(data) && data?.length) {
      callbackFun(data);
    } else if (data?.Value?.table?.length) {
      callbackFun(data?.Value?.table);
    } else {
      callbackFun([]);
    }
  }
};

export const getApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, data, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

// Only Need to Call It When we work with old API Controllers
export const getOldApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      oldTypedResponse(type, callbackFun, data);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

export const getBooleanApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .get(url)
    .then((isResponse) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, isResponse, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

export const postApi = (
  url,
  body,
  callbackFun,
  type,
  getLogout,
  loading,
  isMultiPart,
) => {
  if (loading) message.loading("Please Wait...", 0);

  if (isMultiPart && body) {
    httpClient3
      .post(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else if (body) {
    httpClient
      .post(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else {
    httpClient
      .post(url)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  }
};

export const putApi = (
  url,
  body,
  callbackFun,
  type,
  getLogout,
  loading,
  showSuccess,
) => {
  if (loading) message.loading("Please Wait...", 0);
  if (body) {
    httpClient
      .put(url, body)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  } else {
    httpClient
      .put(url)
      .then(({ data }) => {
        if (loading) message.destroy();
        typedResponse(type, callbackFun, data, url);
      })
      .catch(function (error) {
        onErrorCatch(error, loading, getLogout, url);
      });
  }
};

export const deleteApi = (url, callbackFun, type, getLogout, loading) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .delete(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, data, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

export const patchApi = (
  url,
  callbackFun,
  type,
  getLogout,
  loading,
  showSuccess,
) => {
  if (loading) message.loading("Please Wait...", 0);
  httpClient
    .patch(url)
    .then(({ data }) => {
      if (loading) message.destroy();
      typedResponse(type, callbackFun, data, url);
    })
    .catch(function (error) {
      onErrorCatch(error, loading, getLogout, url);
    });
};

const onErrorCatch = (error, loading, getLogout, url) => {
  message.destroy();

  const status = error?.response?.status;
  const serverMsg =
    error?.response?.data?.message || error?.response?.data?.Message || "";

  const isSessionExpired =
    status === 401 ||
    serverMsg === "Unauthorized." ||
    serverMsg === "Unauthorized" ||
    serverMsg === "Session has expired. Please log in again." ||
    serverMsg === "Token has expired.";

  if (isSessionExpired) {
    message.warn("Session has expired. Please log in again.");
    if (typeof getLogout === "function") getLogout();
  }
};
// const onErrorCatch = (error, loading, getLogout, url) => {
//   if (
//     error?.response?.data?.message ===
//       "Session has expired. Please log in again." ||
//     error?.response?.data?.message === "Token has expired."
//   ) {
//     message.warn(error.response.data.message);
//     getLogout();
//   }
//   if (loading) message.destroy();
// };
